"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var getMonthsToShow = function (_a) {
    var vertical = _a.vertical, _b = _a.monthsToShow, monthsToShow = _b === void 0 ? 1 : _b;
    return vertical ? constants_1.VERTICAL_MONTHS_SHOWN : monthsToShow;
};
exports.default = getMonthsToShow;
